export const colors = {
  black: '#000000',
  white: '#FFFFFF',
  background: '#F5F6F8',
  divider: '#D1D6DC',

  primary: {
    main: '#3669FD',
    dark: '#2E5EE8',
    disabled: '#91B6FF',
  },

  success: {
    main: '#00B96B',
    light: '#D6FAE4',
  },

  error: {
    main: '#F63C23',
    dark: '#E82E14',
    light: '#FEDADA',
  },

  warning: {
    main: '#FCC31A',
    dark: '#FFAF00',
    light: '#FFF3BF',
  },

  overlay: {
    scrim: 'rgba(28, 31, 34, 0.4)',
  },

  text: {
    primary: '#1C1F22',
    secondary: '#494f54',
    disabled: '#868F96',
  },

  highlight: {
    gray25: 'rgba(209, 214, 220, 0.25)',
    gray40: 'rgba(209, 214, 220, 0.4)',
    blue25: 'rgba(184, 205, 255, 0.25)',
    blue40: 'rgba(184, 212, 255, 0.4)',
  },
};

export const zIndex = {
  /** Sticky-панели внутри скролла контента (ActionPanel на «островах»). */
  contentSticky: 50,
  sideMenu: 100,
  header: 200,
  sidebar: 300,
  modal: 400,
  tooltip: 600,
};

export const breakpoint = {
  mobileSmall: 360,
  mobile: 600,
  tablet: 900,
  desktop: 1280,
  /**
   * Порог для CollapsibleListFilters: при ширине viewport ≤ этого значения панель
   * сворачивается в кнопку «Фильтры». Шире, чем `mobile`, чтобы в landscape на
   * телефонах (CSS width часто 700–950px) фильтры не занимали весь экран.
   */
  listFiltersCollapse: 1024,
};

export const device = {
  mobileSmall: `@media (max-width: ${breakpoint.mobileSmall}px)`,
  mobile: `@media (max-width: ${breakpoint.mobile}px)`,
  tablet: `@media (max-width: ${breakpoint.tablet}px)`,
  desktop: `@media (max-width: ${breakpoint.desktop}px)`,
  /** Ширина, при которой показывается боковое меню (как в основной системе). */
  layoutDesktop: `@media (min-width: ${breakpoint.tablet + 1}px)`,
};

export const theme = {
  colors,
  zIndex,
  breakpoint,
  device,
  breakpoints: [`${breakpoint.mobile}px`, `${breakpoint.tablet}px`, `${breakpoint.desktop}px`],
  layout: {
    pagePaddingDesktop: 16,
    pagePaddingMobile: 12,
    /** Высота шапки над рабочей областью (как в web-client). */
    headerHeight: 42,
    /** Скругление верхнего левого угла main в режиме по умолчанию (белая панель). */
    mainContentBorderRadius: 8,
    contentMaxWidth: 1440,
    touchTargetMin: 44,
    /**
     * Внешние (read-only) страницы — «острова» как InfoBlock в web-client /plm/product/…:
     * серая канва; при монтировании переключает main в режим без белой обводки (см. MainLayout).
     */
    externalPage: {
      /** Горизонтальные поля канвы (ориентир ToolsPanelPage: ~20px справа, у миниаппа симметрично). */
      gutterDesktop: 20,
    },
  },
  borderRadius: 4,
  space: [4, 8, 16, 28, 34, 46, 52, 64],
  fontSizes: [9, 10, 11, 12, 13, 14, 15, 16, 20, 24],
  shadows: [
    '0px 1px 2px 0px rgba(28, 31, 34, 0.15)',
    '0px 3px 6px rgba(62, 67, 104, 0.1)',
    '0px 8px 16px rgba(62, 67, 104, 0.1)',
  ],
};

export type Theme = typeof theme;
